
import { mapState, mapGetters } from 'vuex'
import playerProfile from '~/mixins/common/pages/player-profile'
export default {
    mixins: [playerProfile],
    data() {
        return {
            deleteLoading: {},
            formValid: false,
            formData: {
                currency: '',
                email: '',
                phone: '',
                date_of_birth: null,
                address: '',
                city: '',
                country: '',
                province: '',
                social_info: [
                    {
                        id: null,
                        social_media_type: null,
                        social_media_id: '',
                    },
                ],
            },
            existForm: {},
        }
    },
    computed: {
        ...mapGetters({
            loading: 'themes/player/loading',
        }),
        ...mapState({
            loadingPlayer: (state) => state.player.loading,
            player: (state) => state.player.player,
        }),
        availablePlatforms() {
            const filterMediaType = this.formData.social_info.filter(
                (el) => el.social_media_type
            )
            const idOnly = filterMediaType.map((data) => {
                return data.social_media_type
            })
            const filterOut = this.platforms.filter(
                (el) => !idOnly.includes(el.val)
            )
            return filterOut
        },
        isMatch() {
            return this.isEqual(this.formData, this.existForm)
        },
    },
    watch: {
        player(value) {
            this.setFormDataDefaultVal(value)
        },
    },
    mounted() {
        this.setFormDataDefaultVal(this.player)
    },
    beforeDestroy() {
        this.doCancelAxiosRequest()
    },
    methods: {
        addNewSocialItem() {
            if (this.formData?.social_info?.length > 5) return
            this.formData?.social_info?.push({
                id: null,
                social_media_type: null,
                social_media_id: '',
            })
        },
        async deleteSocialItem(item, index) {
            if (item.id) {
                this.deleteLoading[item.id] = true
                const result = await this.$store.dispatch(
                    'themes/player/doDeleteSocial',
                    item.id
                )
                if (result) {
                    this.$delete(this.formData?.social_info, index)
                }
                this.deleteLoading[item.id] = false
            } else {
                this.$delete(this.formData?.social_info, index)
            }
        },
        setFormDataDefaultVal(player) {
            if (!player) return
            const socialInfo = player?.social_info
            this.formData = {
                currency: player?.currency || '',
                email: player?.email || '',
                phone: player?.phone || '',
                date_of_birth: player?.date_of_birth || null,
                address: player?.address || '',
                city: player?.city || '',
                country: player?.country || '',
                province: player?.province || '',
                social_info: player?.social_info?.length
                    ? JSON.parse(JSON.stringify(socialInfo))
                    : [
                          {
                              id: null,
                              social_media_type: null,
                              social_media_id: '',
                          },
                      ],
            }
            this.existForm = JSON.parse(JSON.stringify(this.formData))
        },
        setDate(date) {
            this.formData.date_of_birth = date.trim()
        },
        socialChange(index) {
            const socials = this.formData?.social_info
            const currentSocial = socials[index]
            for (let idx = 0; idx < socials.length; idx++) {
                if (idx === index) continue
                const social = socials[idx]
                if (
                    currentSocial?.social_media_type ===
                    social?.social_media_type
                ) {
                    this.formData.social_info[index].social_media_type = null
                    this.$forceUpdate()
                    break
                }
            }
        },
    },
}
